import { useMemo } from 'react';
import { isEmptyFilter } from '../utils/utils';

export function useFilteredCards(cards, filter, useSubjects = false) {
  return useMemo(() => {
    if(!cards || typeof filter != 'object') {
      return null;
    }

    if(isEmptyFilter(filter, useSubjects)) {
      return cards;
    }

    return cards.filter((card) => {
      if (card.hide_from_listing) {
        return false
      };
      const isAccessPassed = filter.access?.length ? filter.access.includes(card.access) : true;
      const isTypePassed = filter.type?.length
        ? card.meta_type.some((typeItem) => filter.type.includes(typeItem))
        : true;
      const isLevelPassed = filter.level?.length
        ? card.meta_level.some((levelItem) => filter.level.includes(levelItem))
        : true;
      const isCoachPassed = filter.coach?.length
        ? card.coach.some((coachItem) => filter.coach.includes(coachItem))
        : true;
      const isSubjectsPassed = useSubjects
        ? filter.subjects?.length
          ? card.tags.some((tagItem) => filter.subjects?.includes(tagItem.name))
          : true
        : true;
      const isSeriesPassed = filter.hasSeries !== null && filter.hasSeries !== undefined
        ? filter.hasSeries
          ? card?.series?.length > 0
          : !card?.series?.length
        : true;

      return isAccessPassed && isTypePassed && isLevelPassed && isCoachPassed && isSubjectsPassed && isSeriesPassed;
    });
  }, [cards, filter, useSubjects]);
}
